<template>
  <div>
    <div class="content">
      <div class="headCont">
        <div class="slelectCont">
          <a-dropdown>
            <div class="lxBox dis-cent">
              <div class="name">{{ years_name }}</div>
              <div class="iconfont icon-unfold unfold"></div>
            </div>
            <a-menu slot="overlay" @click="hyClick" :selectedKeys="[years_key]">
              <a-menu-item
                :key="item.name + '_' + item.id"
                v-for="item in years"
                >{{ item.name }}</a-menu-item
              >
            </a-menu>
          </a-dropdown>
          <a-dropdown>
            <div class="lxBox dis-cent">
              <div class="name">{{ month_name }}</div>
              <div class="iconfont icon-unfold unfold"></div>
            </div>
            <a-menu
              slot="overlay"
              @click="hyClick1"
              :selectedKeys="[month_key]"
            >
              <a-menu-item
                :key="item.name + '_' + item.id"
                v-for="item in months"
                >{{ item.name }}</a-menu-item
              >
            </a-menu>
          </a-dropdown>
        </div>
        <div class="typeCont">
          <div class="inputBox">
            <input
              type="text"
              placeholder="请输入关键词搜索，如：名称、行业"
              v-model="searChTxt"
              @keyup.enter="searchClick"
            />
          </div>
        </div>
      </div>
      <div class="contBox">
        <Kong v-if="list.length == 0" />
        <div class="zCont" v-for="item in list">
          <div class="shijian">
            <div class="name">{{ item.day }}，{{ item.week }}</div>
            <div
              class="text"
              v-if="item.censoring == 3 || item.censoring == -1"
            >
              面试{{ item.censoring == 3 ? "已同意" : "已拒绝" }}
            </div>
            <div class="text" v-if="item.censoring == 1 || item.censoring == 2">
              {{ item.pd == 1 ? "面试未同意" : "面试已超时" }}
            </div>
          </div>
          <div class="cont" @click="msClick(item.id)">
            <div class="time">{{ item.time }}</div>
            <div class="peoBox">
              <div class="img" @click.stop="jump(item.member_id)">
                <img :src="$imgUrl + item.member.avatars" alt="" srcset="" />
              </div>
              <div class="box" @click.stop="jump(item.member_id)">
                <div class="name">{{ item.member.member_info.realname }}</div>
                <div class="text c-1">{{ item.remark }}</div>
              </div>
            </div>
            <div class="mobileBox">
              <div class="txt">{{ item.member.mobile }}</div>
              <div
                class="iconfont icon-fuzhi_o fuzhi_o"
                @click.stop="fzClick(item)"
              ></div>
            </div>
            <div class="gwBox" v-if="item.job_id">
              面试岗位：{{ item.jobs_name }}
            </div>
            <div class="gwBox" v-if="item.odd_id">
              零工职位：{{ item.odds_name }}
            </div>
            <div
              class="ztBox"
              @click.stop
              v-if="item.censoring == 2 && item.pd == 1"
            >
              <div class="text red" @click.stop>
                <a-popconfirm
                  title="是否确定拒绝"
                  ok-text="是"
                  cancel-text="否"
                  @confirm="jjConfirm(item)"
                >
                  拒绝
                </a-popconfirm>
              </div>
              <div class="text" @click.stop>
                <a-popconfirm
                  title="是否确定同意"
                  ok-text="是"
                  cancel-text="否"
                  @confirm="tyConfirm(item)"
                >
                  同意
                </a-popconfirm>
              </div>
            </div>
          </div>
        </div>
        <div class="fenye" v-if="totalCount > 7">
          <a-pagination
            :default-current="page.pageNo"
            v-model="page.pageNo"
            :total="totalCount"
            :page-size="7"
            @change="pageOnChange"
          />
        </div>
      </div>
    </div>
    <MsCont v-if="msShow" :id="msId" @show="msShow = false" />
    <Jianli :id="peoId" v-if="jlShow" @show="jlShowJs" />
  </div>
</template>

<script>
import { Menu, Form, Input, Dropdown, Upload, Icon } from "ant-design-vue";
import MsCont from "../../component/msCont.vue";
import Kong from "../../component/kong.vue";
import Jianli from "../../component/jianli.vue";
export default {
  components: {
    "a-menu": Menu,
    "a-menu-item": Menu.Item,
    "a-sub-menu": Menu.SubMenu,
    "a-form": Form,
    "a-form-item": Form.Item,
    "a-input": Input,
    "a-dropdown": Dropdown,
    "a-textarea": Input.TextArea,
    "a-upload": Upload,
    "a-icon": Icon,
    Kong,
    MsCont,
    Jianli,
  },
  name: "",
  data() {
    return {
      peoId: "",
      jlShow: false,
    msShow: false,
    judge: true,
      page: {
        pageNo: 1,
        pageSize: 7,
      },
      list: [],
      totalCount: 0,
      years_key: "",
      years_name: "选择年份",
      years: [],
      month_key: "",
      month_name: "选择月份",
      months: [
        {
          id: '',
          name: "全年",
        },
        {
          id: '01',
          name: "1月",
        },
        {
          id: '02',
          name: "2月",
        },
        {
          id: '03',
          name: "3月",
        },
        {
          id: '04',
          name: "4月",
        },
        {
          id: '05',
          name: "5月",
        },
        {
          id: '06',
          name: "6月",
        },
        {
          id: '07',
          name: "7月",
        },
        {
          id: '08',
          name: "8月",
        },
        {
          id: '09',
          name: "9月",
        },
        {
          id: '10',
          name: "10月",
        },
        {
          id: 11,
          name: "11月",
        },
        {
          id: 12,
          name: "12月",
        },
      ],
      searChTxt: "",
    };
  },
  created() {
    this.getYear();
    this.listGet();
  },
  methods: {
    searchClick() {
      console.log(111);
      this.page.name = this.searChTxt;
      this.page.pageNo = 1;
      this.list = [];
      this.totalCount = 0;
      
      this.listGet();
    },
    jlShowJs() {
      this.jlShow = false;
      this.canScroll();
    },
    jump(id) {
      this.peoId = id;
      this.jlShow = true;
      this.stopScroll();
    },
    //禁止滚动
    stopScroll() {
      var mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", mo, false); //禁止页面滑动
    },
    /***取消滑动限制***/
    canScroll() {
      var mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = ""; //出现滚动条
      document.removeEventListener("touchmove", mo, false);
    },
    msClick(id) {
      this.msShow = true;
      this.msId = id;
    },
    pageOnChange(i) {
      this.page.pageNo = i;
      this.totalCount = 0;
      this.listGet();
    },
    timeDb(time2) {
      // 创建两个时间对象
      const time1 = this.$moment();
      time2 = this.$moment(time2);
      // 比较时间
      let pd = 0;
      if (time1.isBefore(time2)) {
        pd = 1;
      } else if (time1.isAfter(time2)) {
        pd = 2;
      } else {
        pd = 3;
      }
      return pd;
    },
    listGet() {
      if (!this.judge) {
        return;
      }
      this.judge = false;
      this.$get("/nozzle/web/interview_gets", this.page).then((res) => {
        console.log(res.data);
        this.judge = true;
        if (this.totalCount == 0) {
          this.totalCount = res.totalCount;
        }
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            const e = res.data[i];
            e.week = this.$moment(e.start_time).format("dddd");
            e.day = this.$moment(e.start_time).format("YYYY年MM月DD日");
            e.time = this.$moment(e.start_time).format("HH:mm");
            e.pd = this.timeDb(e.start_time);
            // if (e.censoring == 1 || e.censoring == -1) {
            //   e.member.member_info.mobile = this.phoJm(
            //     e.member.member_info.mobile
            //   );
            // }
          }
          this.list = res.data;
        } else {
          this.list = [];
        }
      });
    },
    getYear() {
      // 获取当前年份
      const currentYear = new Date().getFullYear();
      // 获取前六年到今年的年份数组
      const years = [];
      for (let i = currentYear - 6; i <= currentYear; i++) {
        years.push({
          name: i + "年",
          id: i,
        });
      }
      this.years = years;
      console.log(years);
    },
    hyClick(e) {
      console.log(e);
      let key = e.key.split("_");
      this.years_key = e.key;
      this.years_name = key[0];
      this.page.year = key[1];
      this.page.pageNo = 1;
      this.totalCount = 0;
      this.listGet();
    },
    hyClick1(e) {
      console.log(e);
      if (!this.years_key) {
        this.$message.warning("请选择年份！");
        return
      }
      let key = e.key.split("_");
      this.month_key = e.key;
      this.month_name = key[0];
      this.page.month = key[1];
      this.page.pageNo = 1;
      this.totalCount = 0;
      this.listGet();
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.content {
  width: 1280px;
  margin: auto;
}
.headCont {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;
  margin-bottom: 10px;
  // height: 60px;

  .typeCont {
    display: flex;
    align-items: center;

    .txt {
      font-size: 12px;
      margin-left: 15px;
      color: #666;
    }

    .inputBox {
      width: 300px;
      height: 35px;
      background-color: #dfedfa;
      margin-left: 20px;
      border-radius: 10px;

      input {
        width: 100%;
        height: 100%;
        padding-left: 15px;
        box-sizing: border-box;
        font-size: 14px;
      }
    }
  }

  .leixList {
    display: flex;
    padding-left: 10px;

    .lxBox {
      margin-left: 15px;
      background-color: #dfedfa;
      height: 30px;
      padding: 0 10px;
      border-radius: 5px;
      color: #666;
      font-size: 13px;
      cursor: pointer;
    }

    .on {
      background-color: #dfedfa;
      color: #147ee0;
      font-weight: 600;
    }
  }

  .typeList {
    display: flex;
    align-items: center;

    .type {
      width: 70px;
      height: 30px;
      cursor: pointer;
      border-radius: 5px;
    }

    .on {
      background-color: #dfedfa;
      color: #147ee0;
    }
  }

  .slelectCont {
    display: flex;
    align-items: center;

    .ssBox {
      height: 35px;
      background-color: #fff;
      width: 160px;
      border-radius: 5px;
      display: flex;

      input {
        width: calc(100% - 35px);
        box-sizing: border-box;
        padding-left: 15px;
      }

      .search {
        width: 35px;
        height: 40px;
        color: #9c9c9c;
        font-size: 18px;
      }
    }

    .lxBox {
      margin-right: 15px;
      height: 40px;
      background-color: #fff;
      border-radius: 5px;
      cursor: pointer;
      color: #666;
      padding: 0 12px 0 15px;

      .unfold {
        font-size: 14px;
        margin-left: 5px;
      }
    }
  }
}
.contBox {
  height: calc(100% - 70px);
  overflow: auto;
  box-sizing: border-box;
  padding: 0 20px 20px;
  .zCont {
    margin-bottom: 20px;
    .shijian {
      margin-bottom: 10px;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .text {
        margin-right: 10px;
        font-size: 14px;
        color: #e95a07;
      }
    }
  }
  .cont {
    cursor: pointer;
    border-radius: 10px;
    border: 1px solid #ebebeb;
    height: 90px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    background-color: #fff;
    .time {
      width: 70px;
      font-size: 18px;
      color: #666;
    }
    .peoBox {
      height: 45px;
      width: 230px;
      display: flex;
      .img {
        width: 45px;
        border-radius: 50%;
        height: 45px;
      }
      .box {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-left: 10px;
        width: calc(100% - 45px);
        box-sizing: border-box;
        .text {
          font-size: 12px;
          color: #9c9c9c;
        }
      }
    }
    .mobileBox {
      display: flex;
      align-items: center;
      width: 200px;
      .fuzhi_o {
        font-size: 20px;
        position: relative;
        top: 1px;
        margin-left: 5px;
        color: #299fff;
        cursor: pointer;
      }
    }
    .gwBox {
      width: calc(100% - 600px);
    }
    .ztBox {
      width: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      .text {
        color: #1596ff;
        margin-left: 15px;
      }
    }
  }
}
</style>
